<ng-container *ngIf="favoritesEnabled">
	<shared-components-auth-snackbar location="PDP"></shared-components-auth-snackbar>
</ng-container>
<ng-template #aboveTheFoldTemplate>
	<pdp-product-image-carousel
		[location]="dynamicTemplateToLoad"
		[product]="product"
		[chainIdentifierAbbr]="chainIdentifierAbbr"
		[killSwitches]="killSwitches"
		[swatchColor]="defaultColor"
		[defaultCustomizedUrls]="(myCustomizerMap$ | async)?.imageURLs"
	></pdp-product-image-carousel>
</ng-template>
<div *ngIf="useAboveTheFoldMobileContainer" class="hmf-display-md-none">
	<div
		class="carousel-initial-styles-{{dynamicTemplateToLoad}}"
		[ngClass]="{'is-pla': isSSRPLAEnabled && isPLAEnabled && isPLA}">
		<ng-container #aboveTheFoldViewRef></ng-container>
	</div>
</div>
<div id="pdp-container" #templateOutlet></div>
